"use strict";

const ResumeUpdateRequest = (() => {
  const REGEX_JA_REQUEST_ITEMS = 'input:checkbox[id^="ja[request_items["]'
  const REGEX_EN_REQUEST_ITEMS = 'input:checkbox[id^="en[request_items["]'
  const REGEX_JA_ID_INPUT_REQUEST_ITEMS = 'input[id^="ja[request_items["]'
  const REGEX_EN_ID_INPUT_REQUEST_ITEMS = 'input[id^="en[request_items["]'
  const EN_RESUME_UPDATE_REQUEST = '.en_resume_update_request'
  const JA_RESUME_UPDATE_REQUEST = '.ja_resume_update_request'
  const JA_NAME_SELECT_MESSAGE_SUGGEST = 'select[name="ja[message_suggests]"]'
  const EN_NAME_SELECT_MESSAGE_SUGGEST = 'select[name="en[message_suggests]"]'
  const JA_TEXTAREA_MESSAGE = 'textarea[name="ja[message]"]'
  const EN_TEXTAREA_MESSAGE = 'textarea[name="en[message]"]'
  const JA_REQUEST_ITEMS_WORK_EXPERICENCE = 'ja[request_items[ja_work_experience]]'
  const EN_REQUEST_ITEMS_WORK_EXPERICENCE = 'en[request_items[en_work_experience]]'
  const JA_ALL_ITEMS = 'ja[all_items]'
  const EN_ALL_ITEMS = 'en[all_items]'
  const JA_CHECKBOX_ALL_ITEMS = `input[id="${JA_ALL_ITEMS}"]`
  const EN_CHECKBOX_ALL_ITEMS = `input[id="${EN_ALL_ITEMS}"]`
  const SUBMIT_INPUT_UPDATE_REQUEST = 'input[type="submit"][name="update_request"]'

  class ResumeUpdateRequest {
    messageSuggestsChange(target) {
      let textareaName = (target.name == 'ja[message_suggests]') ? JA_TEXTAREA_MESSAGE : EN_TEXTAREA_MESSAGE
      $(textareaName).val(target.value)
    }

    enableMessageSuggestSelectBox(id, isEnabled) {
      let messageSuggestJa = (id == JA_REQUEST_ITEMS_WORK_EXPERICENCE) ? $(JA_NAME_SELECT_MESSAGE_SUGGEST) : false
      let messageSuggestEn = (id == EN_REQUEST_ITEMS_WORK_EXPERICENCE) ? $(EN_NAME_SELECT_MESSAGE_SUGGEST) : false
      let messageSuggest   = messageSuggestJa ? messageSuggestJa : messageSuggestEn
      if (messageSuggest) messageSuggest.prop('hidden', isEnabled)
    }

    requestItemChange(target) {
      this.enableMessageSuggestSelectBox(target.id, !target.checked)
      this.checkOrUnCheckAllRequestItems(target.id, target.checked)

      if (target.checked) {
        this.enableSubmit()
      } else {
        let isJaElement = (target.id.indexOf('ja') == 0)
        let element     = isJaElement ? REGEX_JA_ID_INPUT_REQUEST_ITEMS : REGEX_EN_ID_INPUT_REQUEST_ITEMS
        let allItems    = isJaElement ? JA_CHECKBOX_ALL_ITEMS : EN_CHECKBOX_ALL_ITEMS

        $('#all_resumes').is(':checked') ? this.disableSubmit() : this.disableSubmit(element)
        $(allItems).prop('checked', false)
      }
    }

    checkOrUnCheckAllRequestItems(id, isChecked) {
      if (id == JA_ALL_ITEMS) {
        $(REGEX_JA_ID_INPUT_REQUEST_ITEMS).prop('checked', isChecked)
        $(JA_NAME_SELECT_MESSAGE_SUGGEST).prop('hidden', !isChecked) // show/hide messageSuggest ComboBox
      } else if (id == EN_ALL_ITEMS) {
        $(REGEX_EN_ID_INPUT_REQUEST_ITEMS).prop('checked', isChecked)
        $(EN_NAME_SELECT_MESSAGE_SUGGEST).prop('hidden', !isChecked) // show/hide messageSuggest ComboBox
      }
    }

    disableSubmit(elements = `${REGEX_JA_REQUEST_ITEMS}, ${REGEX_EN_REQUEST_ITEMS}`) {
      let isChecked = false
      $(elements).each((_, element) => {
        if (element.checked) {
          isChecked = true
          return false  // exit this loop
        }
      })
      if (!isChecked) $(SUBMIT_INPUT_UPDATE_REQUEST).prop('disabled', true)
    }

    enableSubmit() { $(SUBMIT_INPUT_UPDATE_REQUEST).prop('disabled', false) }

    resumeUpdateRequestHandler(event) {
      let thisClass = this
      event.preventDefault()

      $.ajax({
        dataType: 'json',
        url: event.target.action,
        method: event.target.method,
        data: $(event.target).serializeArray(),
        success: (res) => {
          thisClass.hideResumeUpdateRequestArea()
          thisClass.addBookmarkItem(res)
          thisClass.editTextAfterRemoveLink(res)
          thisClass.showModal()
        },
        fail: (error) => { console.log(error) }
      })
    }

    hideResumeUpdateRequestArea() { $('#update_request').hide('slow') }

    addBookmarkItem(res) {
      $('.insert-note-after-update-request-submited').append(
        `<div class="noteFrameMine">
          <span class="noteHeader">${res.created_at}</span>
          <p class="noteBody">
            <span>${res.title}</span>
            <strong class="mx-4">${res.request_item_contents}</strong>
            <br/>
            <span>${res.message}</span>
          </p>
        </div>`
      )
    }

    editTextAfterRemoveLink(res) {
      $('a[href="#update_request"]').text(res.text_edit_after_remove_link)
      $('a[href="#update_request"]').removeAttr('href')
    }

    showModal() { $('.successModal').modal('show') }
  }

  return ResumeUpdateRequest
})()

export default ResumeUpdateRequest
